import { Card } from "react-bootstrap";
import { ReactNode } from "react";

interface BasePageProps {
    children: ReactNode;
    className?: string;
    bodyClassName?: string;
}

const BasePage = ({ children, className = '', bodyClassName = '' }: BasePageProps) => {
    return (
        <div className={`page ${className}`}>
            <Card className={`${bodyClassName}`}>
                {children}
            </Card>
        </div>
    );
};

export default BasePage;